export default {
  // Page titles
  title: 'อสังหาริมทรัพย์',
  new_property: 'เพิ่มอสังหาริมทรัพย์',
  edit_property: 'แก้ไขอสังหาริมทรัพย์',

  // Descriptions
  description: 'จัดการอสังหาริมทรัพย์ให้เช่า',
  new_description: 'เพิ่มอสังหาริมทรัพย์ใหม่',
  edit_description: 'แก้ไขรายละเอียดอสังหาริมทรัพย์',

  // Tabs
  tabs: {
    overview: 'ภาพรวม',
    units: 'ห้อง',
    general: 'ทั่วไป',
    rooms: 'ห้อง',
    pricing: 'การกำหนดราคา',
    common_area_fees: 'ค่าส่วนกลาง',
    parking: 'ที่จอดรถ',
    microsite: 'ไมโครไซต์',
  },

  // Section titles
  sections: {
    basic_information: 'ข้อมูลพื้นฐาน',
    billing_settings: 'ตั้งค่าการเรียกเก็บเงิน',
    billing_settings_hint: 'อัตราค่าสาธารณูปโภค (ไฟฟ้า น้ำ ฯลฯ) ตั้งค่าได้ในแท็บ "การกำหนดราคา" หลังจากบันทึกอสังหาริมทรัพย์แล้ว',
    // EP-136 (T136-026) — Booking block, sits directly below Billing Settings.
    booking: 'การจอง',
    payment_methods: 'วิธีการชำระเงิน',
    utility_rates: 'อัตราค่าสาธารณูปโภคและสูตรคำนวณ',
    utility_rates_description: 'กำหนดอัตราค่าสาธารณูปโภคและค่าธรรมเนียมเพิ่มเติมสำหรับอสังหาริมทรัพย์นี้ ใช้ในการสร้างใบแจ้งหนี้',
    // EP-86 T010: Essentials/Advanced section grouping
    essentials: 'ข้อมูลสำคัญ',
    contact: 'ข้อมูลติดต่อ',
    tax: 'ภาษี',
    location: 'ที่ตั้ง',
    advanced_options: 'ตัวเลือกขั้นสูง',
    // EP-86 T014: PropertyPricingFields section headings
    pricing_formula: 'สูตรคำนวณราคา',
    common_area_fees: 'ค่าส่วนกลาง',
    // EP-86 T015: PropertyRoomsFields streamlined mode section headings
    area_meters: 'พื้นที่และมิเตอร์',
    room_types: 'ประเภทห้อง',
  },

  // Rooms (streamlined mode quick-add)
  rooms: {
    add_rooms: 'เพิ่มห้องของคุณ',
    unit_number: 'หมายเลขห้อง',
    // F10/AC-8 (EP-158): was the hardcoded English "e.g., APT-101".
    unit_number_placeholder: 'เช่น 101',
    monthly_rent: 'ค่าเช่ารายเดือน (฿)',
    add_unit_button: '+ เพิ่ม',
    added_count: 'เพิ่มแล้ว {{count}} ห้อง',
    streamlined_empty_title: 'ยังไม่มีห้อง',
    streamlined_empty_hint: 'กรอกหมายเลขห้องและค่าเช่ารายเดือนด้านบน แล้วกด "+ เพิ่ม"',
    streamlined_number_required: 'กรอกหมายเลขห้อง',
    streamlined_rent_required: 'กรอกค่าเช่ารายเดือน',
    streamlined_add_required: 'เพิ่มอย่างน้อยหนึ่งห้อง กรอกข้อมูลด้านบน แล้วกด "+ เพิ่ม"',
    // AddUnitModal: Advanced room-type grouping disclosure
    group_into_room_types: 'ขั้นสูง: จัดกลุ่มตามประเภทห้อง',
  },

  // Property types
  property_types: {
    apartment: 'อพาร์ทเมนต์',
    condominium: 'คอนโดมิเนียม',
  },

  // Labels
  labels: {
    property_name: 'ชื่ออสังหาริมทรัพย์',
    property_type: 'ประเภทอสังหาริมทรัพย์',
    address: 'ที่อยู่',
    billing_day: 'วันเรียกเก็บเงิน',
    billing_day_option: 'วันที่ {{day}}',
    // EP-149 T149-017 (MON-8): nullable, แยกจาก billing_day ด้านบน
    payment_due_day: 'วันครบกำหนดชำระ',
    payment_due_day_option: 'วันที่ {{day}}',
    payment_due_day_blank: 'ออกใบแจ้งหนี้ + 15 วัน',
    deposit_type: 'ประเภทเงินประกัน',
    deposit_value_months: 'จำนวนเดือน',
    deposit_value_fixed: 'จำนวนเงินประกัน (฿)',
    pricing_formula: 'สูตรคำนวณค่าเช่า',
    room_types: 'ประเภทห้อง',
    units: 'ห้อง',
    total_units: 'ห้องทั้งหมด',
    vacant_units: 'ห้องว่าง',
    occupied_units: 'ห้องมีผู้เช่า',
    // EP-136 T136-020 — units held by a paid/billed booking fee, distinct
    // from both occupied and vacant.
    reserved_units: 'ห้องที่จองไว้',
    tax_id: 'เลขประจำตัวผู้เสียภาษี',
    branch_number: 'รหัสสาขา',
    phone: 'โทรศัพท์',
    email: 'อีเมล',
    payment_methods_override: 'ใช้การตั้งค่าการชำระเงินเฉพาะอสังหาริมทรัพย์นี้',
    using_account_defaults: 'ใช้การตั้งค่าเริ่มต้นของบัญชี',
    location_url: 'ตำแหน่ง',
    view_on_map: 'ดูบนแผนที่',
  },

  // Placeholders
  placeholders: {
    property_name: 'เช่น Peerapat Residence',
    address: 'เช่น 123 ถนนหลัก',
    tax_id: 'เช่น 1234567890123',
    branch_number: '00000 สำหรับสำนักงานใหญ่',
    phone: 'เช่น 02-123-4567',
    email: 'เช่น info@property.com',
    location_url: 'https://maps.google.com/...',
    bank_name_example: 'ธนาคารกรุงเทพ',
    account_number_example: '123-4-56789-0',
    account_name_example: 'Peerapat Residence',
  },

  // Deposit types
  deposit_types: {
    months: 'เดือนของค่าเช่า',
    fixed: 'จำนวนคงที่ (฿)',
  },

  // EP-136 (T136-026) — per-property booking settings, falling back to the
  // account-level defaults in Settings PER KEY (Property#resolved_booking_settings).
  booking: {
    description: 'แต่ละการตั้งค่าด้านล่างสามารถใช้ค่าเริ่มต้นของบัญชี (ตั้งค่าได้ที่หน้าตั้งค่า → บัญชี) หรือกำหนดค่าเฉพาะสำหรับอสังหาริมทรัพย์นี้ก็ได้',
    fee_mode_label: 'รูปแบบค่าจอง',
    fee_default_label: 'จำนวนเงินค่าจองเริ่มต้น',
    forfeit_label: 'ริบค่าจองเมื่อยกเลิก',
    fee_mode_options: {
      deposit: 'เป็นเงินประกัน — นับรวมในเงินประกัน คืนเงินได้',
      revenue: 'เป็นรายได้ — ค่าธรรมเนียมการจองที่ไม่คืนเงิน',
    },
    override_toggle_label: 'กำหนดค่าเฉพาะอสังหาริมทรัพย์นี้',
    overridden_badge: 'กำหนดเอง',
    inherited_badge: 'ใช้ค่าเริ่มต้น',
    inherited_value: 'ค่าเริ่มต้นของบัญชี: {{value}}',
    fee_default_not_set: 'ยังไม่ได้ตั้งค่าเริ่มต้น — ต้องกรอกจำนวนเงินทุกครั้งที่จองห้อง',
    forfeit_forfeited: 'ริบเมื่อยกเลิก',
    forfeit_refunded: 'คืนเงินเมื่อยกเลิก',
  },

  // Validation
  validation: {
    name_required: 'กรุณากรอกชื่ออสังหาริมทรัพย์',
    must_be_positive: 'ต้องเป็นจำนวนบวก',
  },

  // Room types
  room_types: {
    // EP-54: Thai has no plural inflection; single base key.
    count: '{{count}} ประเภทห้อง',
    title: 'ประเภทห้อง',
    add: 'เพิ่มประเภทห้อง',
    name: 'ชื่อประเภทห้อง',
    name_placeholder: 'เช่น สตูดิโอ, 1 ห้องนอน',
    floor: 'ชั้น',
    floor_placeholder: 'เช่น 1, G, B1',
    empty: 'ไม่มีประเภทห้อง',
    empty_description: 'เพิ่มประเภทห้องเพื่อเริ่มจัดระเบียบห้องของคุณ',
    import_spreadsheet: 'นำเข้าจากสเปรดชีต',
    prefill_pending: 'รอดำเนินการนำเข้า ดูตัวอย่างเท่านั้น',
    importing_units: 'กำลังดำเนินการนำเข้า {{count}} ห้อง',
    imported_units: '✓ นำเข้า {{count}} ห้องเรียบร้อย กดถัดไป',
  },

  // Pricing formula
  pricing: {
    title: 'สูตรคำนวณค่าเช่า',
    add_item: 'เพิ่มรายการ',
    item_name: 'ชื่อรายการ',
    item_type: 'ประเภท',
    rate: 'อัตรา',
    unit: 'หน่วย',
    amount: 'จำนวน',
    minimum: 'ขั้นต่ำ',
    types: {
      metered: 'ตามมิเตอร์',
      fixed: 'คงที่',
      percentage: 'เปอร์เซ็นต์',
    },
  },

  // PricingFormulaEditor — all user-facing strings (task-108)
  pricing_editor: {
    presets: {
      rent: { name: 'ค่าเช่า' },
      water: { name: 'ค่าน้ำ' },
      electricity: { name: 'ค่าไฟฟ้า' },
      common_fee: { name: 'ค่าส่วนกลาง', name_long: 'ค่าส่วนกลาง' },
      internet: { name: 'ค่าอินเทอร์เน็ต' },
      garbage: { name: 'ค่าขยะ' },
      parking: { name: 'ค่าที่จอดรถ' },
    },
    types: {
      metered: 'ตามการใช้งาน',
      fixed: 'ราคาคงที่',
      percentage: 'เปอร์เซ็นต์ของยอดรวม',
      per_sqm: 'ต่อตารางเมตร',
      per_share_ratio: 'ตามสัดส่วนพื้นที่ส่วนกลาง',
    },
    units: {
      unit: 'หน่วย',
      kwh: 'กิโลวัตต์ชั่วโมง',
      cubic_meter: 'ลูกบาศก์เมตร (ม³)',
    },
    // Accessible names for ฿ / % inputs (task-107B)
    aria: {
      rate: 'อัตรา{{name}}',
      minimum: 'ขั้นต่ำ{{name}}',
      amount: 'จำนวนเงิน{{name}}',
      percentage: 'เปอร์เซ็นต์{{name}}',
      per_sqm: 'อัตรา{{name}}ต่อตารางเมตร',
      per_share_ratio: 'ฐาน{{name}} × สัดส่วนพื้นที่ส่วนกลางของยูนิต',
      type: 'ประเภท{{name}}',
      unit: 'หน่วย{{name}}',
      // EP-114 T014/T015 (S2-11) — ปุ่มเลื่อนขึ้น/ลงถูกแทนที่ด้วยที่จับลากเดียว
      drag_handle: 'จัดลำดับ{{name}} รายการที่ {{position}} จาก {{total}}',
      remove: 'ลบ{{name}}',
    },
    // EP-114 T015 (S2-11) — ข้อความสำหรับโปรแกรมอ่านหน้าจอของการลากจัดลำดับ
    dnd: {
      role_description: 'รายการราคาที่จัดลำดับได้',
      instructions:
        'หากต้องการจัดลำดับรายการราคา กดปุ่มเว้นวรรคหรือ Enter ที่ปุ่มจัดลำดับเพื่อยกรายการขึ้น ใช้ปุ่มลูกศรขึ้นและลงเพื่อเลื่อน แล้วกดเว้นวรรคหรือ Enter อีกครั้งเพื่อวางในตำแหน่งใหม่ กด Escape เพื่อยกเลิก',
      picked_up: 'ยก{{name}}ขึ้นแล้ว อยู่ที่รายการที่ {{position}} จาก {{total}}',
      moved_over: 'ย้าย{{name}}ไปที่ตำแหน่งที่ {{position}} จาก {{total}}',
      dropped: 'วาง{{name}}ที่ตำแหน่งที่ {{position}} จาก {{total}}',
      cancelled: 'ยกเลิกการจัดลำดับแล้ว {{name}}ยังอยู่ที่ตำแหน่งที่ {{position}} จาก {{total}}',
    },
    placeholders: {
      minimum: 'ขั้นต่ำ (ไม่บังคับ)',
    },
    empty_state: 'ยังไม่ได้ตั้งค่ารายการราคา เพิ่มค่าสาธารณูปโภคด้านล่าง',
    cta: {
      add_defaults: 'เพิ่มค่าเริ่มต้นอพาร์ตเมนต์ไทยทั่วไป',
      add_custom: 'เพิ่มรายการที่กำหนดเอง',
      pick_preset: 'เลือกจาก preset',
    },
    quick_add: 'เพิ่มด่วน:',
    add_custom: 'เพิ่มรายการที่กำหนดเอง',
    add_item_button: 'เพิ่มรายการ',
    custom_item_label: 'ชื่อรายการที่กำหนดเอง',
    custom_item_placeholder: 'เช่น เคเบิลทีวี, บริการซักรีด',
    of_total: 'ของยอดรวม',
    per_month: 'ต่อเดือน',
    per_sqm_unit: '× พื้นที่ยูนิต (ม²)',
    per_share_ratio_unit: '× สัดส่วนพื้นที่ส่วนกลางของยูนิต',
    minimum_suffix: '(ขั้นต่ำ {{amount}})',
  },

  // Bulk readings
  bulk_readings: {
    title: 'บันทึกมิเตอร์',
    description: 'บันทึกค่ามิเตอร์ทุกห้อง',
  },

  // Empty states
  empty: {
    title: 'ไม่มีอสังหาริมทรัพย์',
    description: 'เริ่มต้นด้วยการสร้างอสังหาริมทรัพย์แรก',
  },

  // Setup guide
  setup_guide: {
    title: 'ยินดีต้อนรับสู่อสังหาริมทรัพย์',
    description:
      'อสังหาริมทรัพย์เป็นพื้นฐานของ FlowRent เริ่มต้นด้วยการสร้างอสังหาริมทรัพย์แรก จากนั้นเพิ่มประเภทห้อง ห้อง และมิเตอร์',
    step_1_title: 'สร้างอสังหาริมทรัพย์',
    step_1_description: 'เพิ่มอพาร์ทเมนต์หรืออาคารพร้อมที่อยู่และการตั้งค่าการเรียกเก็บเงิน',
    step_2_title: 'กำหนดประเภทห้อง',
    step_2_description: 'ตั้งค่าหมวดหมู่ เช่น สตูดิโอ, 1 ห้องนอน, 2 ห้องนอน พร้อมข้อมูลชั้น',
    step_3_title: 'เพิ่มห้องแต่ละห้อง',
    step_3_description: 'สร้างห้องในแต่ละประเภทห้องพร้อมรายละเอียดราคา',
    step_4_title: 'ตั้งค่ามิเตอร์',
    step_4_description: 'ตั้งค่ามิเตอร์น้ำและไฟฟ้าสำหรับแต่ละห้อง',
    import: 'นำเข้าจากไฟล์',
    import_off_scope_warning: 'พบ {{count}} แถว {{entity}} นำเข้าจากหน้า {{Entity}}',
    download_sample: 'ดาวน์โหลดตัวอย่าง',
    seed_sample: 'เพิ่มข้อมูลตัวอย่าง',
    seed_sample_confirm: 'ระบบจะสร้าง: อสังหาริมทรัพย์ 1 รายการ + ประเภทห้อง 1 ประเภท + ห้อง 1 ห้อง ต้องการดำเนินการต่อหรือไม่?',
    seed_sample_success: 'สร้างอสังหาริมทรัพย์ตัวอย่าง (พร้อมประเภทห้องและห้อง) สำเร็จ',
    seed_sample_noop: 'มีอสังหาริมทรัพย์อยู่แล้ว ไม่ได้เพิ่มข้อมูลตัวอย่าง',
  },

  // Late fee policy
  late_fee_policy: {
    title: 'นโยบายค่าปรับล่าช้า',
    enable_label: 'คิดค่าปรับล่าช้าโดยอัตโนมัติสำหรับใบแจ้งหนี้ที่เกินกำหนด',
    fee_type_label: 'ประเภทค่าปรับ',
    fee_type_fixed: 'จำนวนคงที่',
    fee_type_percentage: 'เปอร์เซ็นต์',
    amount_label: 'จำนวน',
    amount_hint_percentage: 'คำนวณจากยอดค้างชำระ',
    grace_period_label: 'ระยะเวลาผ่อนผัน (วัน)',
    grace_period_hint: 'จำนวนวันหลังครบกำหนดก่อนคิดค่าปรับ 0 = เริ่มวันแรกหลังครบกำหนด',
    disable_warning: 'การปิดใช้งานไม่ได้ลบค่าปรับที่เพิ่มไปแล้ว ต้องแก้ไขใบแจ้งหนี้เพื่อลบออก',
    save_button: 'บันทึกนโยบายค่าปรับ',
    save_success: 'บันทึกนโยบายค่าปรับแล้ว',
    save_error: 'บันทึกไม่สำเร็จ กรุณาตรวจสอบแบบฟอร์ม',
    unit_override: 'ปรับแต่งสำหรับห้องนี้',
    use_property_default: 'ใช้ค่าเริ่มต้นของอาคาร',
    clear_override: 'ล้างการปรับแต่ง',
  },

  // Explainer cards
  explainer: {
    pricing: {
      body: 'กำหนดอัตราค่าสาธารณูปโภคและค่าธรรมเนียมประจำที่ผู้เช่าต้องชำระ ตัวอย่างบิลด้านขวาจะอัปเดตตามที่คุณแก้ไข',
      details: 'สูตรคำนวณราคาเป็นตัวกำหนดรายการในใบแจ้งหนี้ทุกรายการ สูตรที่ถูกต้องจะทำให้ผู้เช่าเห็นบิลที่คาดเดาได้และคุณใช้เวลาตอบคำถามน้อยลง ตัวอย่างบิลใช้การบริโภคทั่วไป (น้ำ 10 หน่วย ไฟฟ้า 50 หน่วย) เพื่อให้ตรวจสอบตัวเลขก่อนบันทึก',
    },
    late_fee: {
      body: 'เรียกเก็บค่าปรับโดยอัตโนมัติเมื่อผู้เช่าชำระเงินหลังวันครบกำหนด',
      details: 'ค่าปรับล่าช้าสร้างแรงจูงใจทางการเงินในการชำระเงินตรงเวลาโดยไม่ต้องติดตามด้วยตนเอง ระยะเวลาผ่อนผันช่วยให้รับมือกับความล่าช้าไม่กี่วันก่อนที่จะมีค่าปรับ การปิดใช้งานไม่ได้ลบค่าปรับที่เพิ่มไปแล้ว ต้องแก้ไขใบแจ้งหนี้เพื่อลบออก',
    },
  },

  // Actions
  actions: {
    add_property: 'เพิ่มอสังหาริมทรัพย์',
    import_ai: 'นำเข้าด้วย AI',
    create_property: 'สร้างอสังหาริมทรัพย์',
    view_readings: 'บันทึกมิเตอร์',
    // P007: building-level reports deep-link affordance
    view_building_reports: 'รายงานอาคาร',
    view_building_pl: 'กำไร-ขาดทุน',
    view_building_overdue: 'ใบแจ้งหนี้ค้างชำระ',
  },

  // Messages
  messages: {
    delete_title: 'ลบอสังหาริมทรัพย์',
    delete_confirm: 'ลบ "{{name}}"? จะลบประเภทห้องและห้องทั้งหมดด้วย',
    created: 'สร้างอสังหาริมทรัพย์สำเร็จ',
    updated: 'แก้ไขอสังหาริมทรัพย์สำเร็จ',
    deleted: 'ลบอสังหาริมทรัพย์สำเร็จ',
    unsaved_changes_title: 'มีการเปลี่ยนแปลงที่ยังไม่ได้บันทึก',
    unsaved_changes_body: 'คุณมีการเปลี่ยนแปลงที่ยังไม่ได้บันทึก ต้องการออกจากหน้านี้ใช่หรือไม่?',
  },

  // Errors (Zod validation messages)
  errors: {
    name_required: 'กรุณากรอกชื่ออสังหาริมทรัพย์',
    invalid_email: 'อีเมลไม่ถูกต้อง',
    invalid_url: 'URL ไม่ถูกต้อง',
  },

  // PricingPreview component strings
  pricing_preview: {
    breakdown_aria_label: 'รายละเอียดราคา',
    aria_label: 'ตัวอย่างบิล',
    title: 'ตัวอย่างบิล',
    mobile_summary: 'ตัวอย่างบิล รวม: {{total}}',
    loading: 'กำลังคำนวณ…',
    error: 'ไม่สามารถแสดงตัวอย่างได้',
    // F10/AC-8 (EP-158): the subtitle used to join raw object keys
    // ("water"/"electricity") straight in, reading English on a Thai screen.
    water_label: 'น้ำ',
    electricity_label: 'ไฟ',
    consumption_item: '{{label}} {{value}} หน่วย',
    estimate_note:
      'ประมาณการจากปริมาณการใช้ตัวอย่าง ใบแจ้งหนี้จริงจะใช้ค่ามิเตอร์ที่บันทึกไว้และรวมค่าส่วนกลาง (ถ้ามี) ยอดรวมสุดท้ายจึงอาจแตกต่างกัน',
  },

  // EP-56 L3 — multi-line formula transparency block (audit panel)
  formula_transparency: {
    title: 'คำนวณยังไง?',
    show: 'แสดง',
    hide: 'ซ่อน',
  },
}
